import React from "react";
import { ArrowRight, Check } from "lucide-react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { referenzen: r } = content;

export const Referenzen = () => (
  <Section id="referenzen" testId="section-referenzen" className="has-lines overflow-hidden bg-[#f5f6f4]">
    <FlowLines color="#0F9D6E" opacity={[0.055, 0.045]} />
    <Container>
      <Reveal>
        <Label>{r.label}</Label>
        <AccentH2 className="mt-6 max-w-[840px] font-bold text-[#1e2532]">{r.h2}</AccentH2>
        <p className="mt-6 max-w-[720px] text-[17px] leading-[1.8] text-[#565f70]">{r.intro}</p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-7">
        {r.cases.map((c, i) => (
          <Reveal key={c.name}>
            <article
              data-testid={`reference-card-${i}`}
              className="card-hover flex h-full flex-col overflow-hidden rounded-[16px] border border-[#dfe2e0] border-t-[3px] border-t-[#0f9d6e] bg-white"
            >
              <div className="flex flex-1 flex-col p-7 md:p-8">
                <div className="flex items-center justify-between gap-4">
                  <div className="flex h-[50px] items-center">
                    <img
                      src={c.logo}
                      alt={`Logo ${c.name}`}
                      loading="eager"
                      decoding="async"
                      className="h-[var(--ch)] w-auto max-w-[165px] object-contain"
                      style={{ "--ch": `${c.logoH || 40}px`, filter: "grayscale(1) contrast(1.05)" }}
                    />
                  </div>
                  <span className="font-display text-[13px] font-bold tracking-[0.14em] text-[#c6cbc8]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-6 text-[19px] font-semibold leading-[1.3] text-[#1e2532]">{c.name}</h3>
                <span className="accent-rule mt-4" />
                <p className="mt-5 text-[15.5px] leading-[1.74] text-[#565f70]">{c.text}</p>
              </div>
              <div className="mt-auto border-t border-[#e3ece7] bg-[#f2f8f5] px-7 py-6 md:px-8">
                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#0b7d57]">
                  Ergebnisse
                </p>
                <ul className="mt-4 space-y-3">
                  {c.metrics.map((m) => (
                    <li key={m} className="flex gap-3 text-[15px] font-medium leading-[1.55] text-[#1e2532]">
                      <span className="mt-[2px] flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-[#0f9d6e]">
                        <Check size={11} strokeWidth={3} className="text-white" />
                      </span>
                      {m}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <a
          href={r.link}
          data-testid="referenzen-link"
          className="group mt-12 inline-flex items-center gap-3 text-[15px] font-bold uppercase tracking-[0.08em] text-[#1e2532]"
        >
          <span className="link-underline">{r.linkLabel}</span>
          <ArrowRight size={18} />
        </a>
      </Reveal>
    </Container>
  </Section>
);
